import { z } from 'zod';
/**
 * Checks a row's primary care provider against the one already stored for the patient. The three
 * provider fields are optional because a caller compares whichever of them the feed carries.
 */
export const FeedValidateCareProviderQuerySchema = z
    .object({
    practiceId: z.string().min(1),
    patientEhrId: z.string().min(1),
    primaryCareProviderFirstName: z.string().min(1).optional(),
    primaryCareProviderLastName: z.string().min(1).optional(),
    primaryCareProviderNpi: z.string().min(1).optional(),
})
    .strict();
//# sourceMappingURL=careProvider.js.map